<template>
  <div id="app">
    <Home />
  </div>
</template>

<script>
import Home from './views/Home.vue';

export default {
  name: 'App',
  components: {
    Home
  }
};
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
}
@font-face {
  font-family: 'SourceHanSerifCNBold';
  src: url('https://ro.zlongame.com/fonts/SourceHanSerifCN-Bold.otf')
    format('opentype');
}
i {
  display: block;
}
#app {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
</style>
